import { TimberBuyerContactPreferences } from '@features/TimberBuyer/ContactPreferences'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/timberbuyer/$timberBuyerId/contactpreferences/')({
  component: TimberBuyerContactPreferencesRoute,
  staticData: {
    breadcrumb: 'Kontaktpreferanser',
  },
})

function TimberBuyerContactPreferencesRoute() {
  const { timberBuyerId } = Route.useParams()

  return <TimberBuyerContactPreferences timberBuyerId={timberBuyerId} />
}
